import { render, staticRenderFns } from "./ChoferDocumento.vue?vue&type=template&id=c64ecb50"
import script from "./ChoferDocumento.vue?vue&type=script&lang=js"
export * from "./ChoferDocumento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports